import { h } from 'preact';

function NoSectionIcon ({ color, height = '46', width = '61' }) {
  const fillColor = color || '#9DA4B1';
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 61 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="28"
        y="21"
        width="28"
        height="21"
        rx="2"
        transform="rotate(180 28 21)"
        fill={fillColor}
      />
      <rect
        x="61"
        y="21"
        width="28"
        height="21"
        rx="2"
        transform="rotate(180 61 21)"
        fill={fillColor}
      />
      <rect
        x="28"
        y="46"
        width="28"
        height="21"
        rx="2"
        transform="rotate(180 28 46)"
        fill={fillColor}
      />
      <rect
        x="61"
        y="46"
        width="28"
        height="21"
        rx="2"
        transform="rotate(180 61 46)"
        fill={fillColor}
      />
    </svg>
  );
}

export default NoSectionIcon;
